// Lib
import React, { ReactElement } from 'react';

// Utils
import { isCenteredTextAlignActive } from '../../../../../../common/tiptap/extensions/TextAlign';

// Hooks
import {
    ActiveTiptapEditorSelector,
    useActiveTiptapEditorTouchCallback,
    useTiptapActiveEditorSelector,
} from '../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

// Components
import RichTextTool from './RichTextTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

const isCenteredTextAlignButtonEnabled: ActiveTiptapEditorSelector = (editor) =>
    // NOTE: When changing from a normal card to a task card, the setTextAlign command is not available.
    //  This tool will be displayed in the out-going toolbar, so we need to ensure it still works
    editor?.can().setTextAlign?.('center') || false;

const TiptapCenterTextTool = (props: ToolbarToolProps): ReactElement => {
    const isActive = useTiptapActiveEditorSelector(isCenteredTextAlignActive);
    const isEnabled = useTiptapActiveEditorSelector(isCenteredTextAlignButtonEnabled);

    const toggleCenter = useActiveTiptapEditorTouchCallback(
        (activeEditor, event) => {
            event?.preventDefault();

            const currentlyActive = isCenteredTextAlignActive(activeEditor);
            currentlyActive ? activeEditor.commands.unsetTextAlign() : activeEditor.commands.setTextAlign('center');
        },
        [],
    );

    return (
        <RichTextTool
            isActive={isActive}
            disabled={!isEnabled}
            iconName={props.iconName || 'toolbar-center-text'}
            onClick={toggleCenter}
            {...props}
        />
    );
};

export default TiptapCenterTextTool;
